module.exports = __webpack_public_path__ + "img/L.a2b6ad86.jpg";